<template>
  <div ref="chatMessages" class="chat-messages">
    <div class="chat-messages-list">
      <div
        v-for="(message, index) in messages"
        :key="index"
        class="chat-messages-list-item"
      >
        <div
          v-if="message.to === 'Bot'"
          class="chat-messages-list-item-user"
        >
          <b-skeleton  width="60%"/>
        </div>
        <div
          v-else
          class="chat-messages-list-item-other"
        >
          <b-skeleton  width="60%"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ChatMessagesLoading',
  data () {
    return {
      messages: [
        {
          to: 'Bot',
          message: 'Carregando'
        },
        {
          to: 'Bot',
          message: 'Carregando'
        },
        {
          to: 'Bot',
          message: 'Carregando'
        }
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/atendimento/components/chat/ChatMessagesLoading.vue